import React from "react";
import { useTranslation } from "react-i18next";

//접속자 아이디
//접속자 권한
//버튼들

export default function ReportCardButtonBar({
  handleModifyMode,
  initiateApproval,
  handlePrint,
  handleBulkPrint,
  adminMode,
  contentToPrint,
  modifyMode,
  showPageNumbers,
  setShowPageNumbers,
  showAdditionalInfo,
  setShowAdditionalInfo,
  componentsToFormsData,
  isCooldownActive,
  cooldownRemaining,
  isDataLoading,
}) {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ width: "110px" }} className="me-1 text-center">
        <button
          className="btn btn-warning d-none"
          type="button"
          onClick={adminMode}
          disabled={modifyMode}
        >
          {t("teacher.printingRelated.adminMode")}
        </button>
      </div>

      <div style={{ width: "100px" }} className="me-1 text-center">
        <button
          className="btn btn-primary"
          type="button"
          onClick={handleModifyMode}
          name={modifyMode ? "modifyOn" : "modifyOff"}
        >
          {modifyMode
            ? t("teacher.printingRelated.modifyOff")
            : t("teacher.printingRelated.modifyOn")}
        </button>
      </div>
      <div style={{ width: "70px" }} className="me-1 text-center">
        <button
          className="btn btn-success"
          type="button"
          name="approval"
          onClick={initiateApproval}
          disabled={modifyMode}
        >
          {t("teacher.printingRelated.approval")}
        </button>
      </div>
      <div style={{ width: "100px" }} className="me-1 text-center">
        <button
          className="btn btn-success"
          type="button"
          name="bulkApproval"
          onClick={initiateApproval}
          disabled={modifyMode}
        >
          {t("teacher.printingRelated.bulkApproval")}
        </button>
      </div>
      <div style={{ width: "70px" }} className="me-1 text-center">
        <button
          className="btn btn-info"
          type="button"
          onClick={() => {
            handlePrint(null, () => contentToPrint.current);
          }}
          disabled={modifyMode || isDataLoading}
        >
          {t("common.labels.print")}
        </button>
      </div>
      <div style={{ width: "100px" }} className="me-1 text-center">
        <button
          className="btn btn-primary px-1"
          type="button"
          onClick={handleBulkPrint}
          disabled={modifyMode || isCooldownActive}
        >
          {isCooldownActive
            ? `${cooldownRemaining}초 대기`
            : t("common.labels.bulkPrint") || "반일괄인쇄"}
        </button>
      </div>
      <div className="form-check d-flex flex-column align-items-center ps-0">
        <label className="form-check-label" htmlFor="pageNumbers">
          {t("teacher.printingRelated.pageNumbers")}
        </label>
        <input
          className="form-check-input m-auto"
          type="checkbox"
          id="pageNumbers"
          checked={showPageNumbers}
          onChange={(e) => setShowPageNumbers(e.target.checked)}
        />
      </div>

      {componentsToFormsData &&
        componentsToFormsData.some(
          (item) =>
            item.customized_contents && "hide" in item.customized_contents
        ) && (
          <div className="form-check d-flex flex-column align-items-center ps-0 ms-2">
            <label className="form-check-label" htmlFor="additionalInfo">
              {(() => {
                const foundItem = componentsToFormsData.find(
                  (item) =>
                    item.customized_contents &&
                    "hideName" in item.customized_contents
                );
                return (
                  foundItem?.customized_contents?.hideName ||
                  t("teacher.printingRelated.additionalInfo")
                );
              })()}
            </label>
            <input
              className="form-check-input m-auto"
              type="checkbox"
              id="additionalInfo"
              checked={showAdditionalInfo}
              onChange={(e) => setShowAdditionalInfo(e.target.checked)}
            />
          </div>
        )}
    </>
  );
}
